import React, { useEffect, useState, useCallback } from 'react';
import css from './css/StudentSurveyList.scss';
import StudentSurveyListTable from './StudentSurveyListTable';
import useStarfishAPI from 'hooks/useStarfishAPI';
import PropTypes from 'prop-types';
import ErrorMessage from 'common/ErrorMessage';
import {getWord} from 'utils/tenant';

const StudentSurveyList = ({duplicateTemplate, editSurvey, tenantDateFormat, displayToast}) => {

    const [getSurveysResponse, getSurveysAPI] = useStarfishAPI({ isNewAPI: true });
    const [, changeStatusAPI] = useStarfishAPI({ isNewAPI: true });
    const [surveys, setSurveys] = useState(null);
    const [error, setError] = useState(false);

    const studentSurveyCustomLanguage = getWord('studentSurvey', true);

    const fetchSurveys = useCallback(() => {
        getSurveysAPI('../api/student-survey-template', { method: 'GET' });
    }, []);

    useEffect(() => {
        fetchSurveys();
    }, []);

    useEffect(() => {
        if (getSurveysResponse.success) {
            setSurveys(getSurveysResponse.data);
        } else if (!getSurveysResponse.pending && getSurveysResponse.error) {
            setError(true)
        }
    }, [getSurveysResponse]);

    // Pause or unpause a survey
    const changeSurveyStatus = (surveyId, currentStatus) => {
        const enable = currentStatus.toUpperCase() === 'PAUSED'
        changeStatusAPI(`../api/student-survey-template/${surveyId}`, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({enabled: enable})
        }).then(response => {
            if (response.success) {
                displayToast(`Successfully ${enable ? 'unpaused' : 'paused'}. ${getWord('studentSurvey', false)} is in ${response.data.status.toLowerCase()} status.`);
                fetchSurveys()
            } else {
                displayToast(`Failed to make the update for the ${studentSurveyCustomLanguage}. Please try again. If this error continues to appear, please contact Starfish support.`)
            }
        })
    }

    return (
        <div className={css['container']}>
            {error && <ErrorMessage message={`There was an error retrieving the ${studentSurveyCustomLanguage} list. If this error continues to appear, please contact Starfish support.`} />}
            {surveys &&
                <div className={css['survey-list-table']}>
                    <StudentSurveyListTable
                        duplicateTemplate={duplicateTemplate}
                        changeSurveyStatus={(surveyId, currentStatus) => changeSurveyStatus(surveyId, currentStatus)}
                        editSurvey={editSurvey}
                        surveys={surveys}
                        tenantDateFormat={tenantDateFormat} />
                </div>
            }
        </div>
    );
}

StudentSurveyList.propTypes = {
    duplicateTemplate: PropTypes.func.isRequired,
    editSurvey: PropTypes.func.isRequired,
    displayToast: PropTypes.func.isRequired,
    tenantDateFormat: PropTypes.string.isRequired
};

export default StudentSurveyList;
